import gettingStarted from './content/getting-started';
import projects from './content/projects';
import projectDetail from './content/project-detail';
import sessionDashboard from './content/session-dashboard';
import sessionTranscript from './content/session-transcript';
import sessionAvatars from './content/session-avatars';
import sessionContributions from './content/session-contributions';
import sessionGuidance from './content/session-guidance';
import sessionRequirements from './content/session-requirements';
import sessionDecisions from './content/session-decisions';
import sessionGovernance from './content/session-governance';
import sessionTasks from './content/session-tasks';
import sessionDevices from './content/session-devices';
import sessionSecondScreen from './content/session-second-screen';
import sessionMeetings from './content/session-meetings';
import avatarsCatalog from './content/avatars-catalog';
import templatesCatalog from './content/templates-catalog';
import sessionCreator from './content/session-creator';
import buildWithAi from './content/build-with-ai';

export interface HelpTopic {
  title: string;
  category: string;
  content: string;
}

export const helpTopics: Record<string, HelpTopic> = {
  'getting-started': {
    title: 'Getting Started',
    category: 'General',
    content: gettingStarted,
  },
  'projects': {
    title: 'Projects',
    category: 'General',
    content: projects,
  },
  'project-detail': {
    title: 'Project Detail',
    category: 'General',
    content: projectDetail,
  },
  'session-creator': {
    title: 'Creating a Session',
    category: 'General',
    content: sessionCreator,
  },
  'session-dashboard': {
    title: 'Session Dashboard',
    category: 'Session',
    content: sessionDashboard,
  },
  'session-transcript': {
    title: 'Transcript',
    category: 'Session',
    content: sessionTranscript,
  },
  'session-avatars': {
    title: 'Avatars',
    category: 'Session',
    content: sessionAvatars,
  },
  'session-contributions': {
    title: 'Contributions',
    category: 'Session',
    content: sessionContributions,
  },
  'session-guidance': {
    title: 'Facilitator Guidance',
    category: 'Insights',
    content: sessionGuidance,
  },
  'session-requirements': {
    title: 'Requirements & Personas',
    category: 'Insights',
    content: sessionRequirements,
  },
  'session-decisions': {
    title: 'Decisions',
    category: 'Insights',
    content: sessionDecisions,
  },
  'session-governance': {
    title: 'AI Governance',
    category: 'Insights',
    content: sessionGovernance,
  },
  'session-tasks': {
    title: 'Session Tasks',
    category: 'Tools',
    content: sessionTasks,
  },
  'session-devices': {
    title: 'Devices',
    category: 'Tools',
    content: sessionDevices,
  },
  'session-second-screen': {
    title: 'Second Screen',
    category: 'Tools',
    content: sessionSecondScreen,
  },
  'session-meetings': {
    title: 'Meeting Integration',
    category: 'Tools',
    content: sessionMeetings,
  },
  'avatars-catalog': {
    title: 'Avatar Catalog',
    category: 'Catalog',
    content: avatarsCatalog,
  },
  'templates-catalog': {
    title: 'Template Catalog',
    category: 'Catalog',
    content: templatesCatalog,
  },
  'build-with-ai': {
    title: 'Build with AI',
    category: 'Catalog',
    content: buildWithAi,
  },
};

// Map route patterns and LiveSession activeView values to help topic slugs
export function resolveTopicFromRoute(pathname: string, activeView?: string | null): string {
  // LiveSession views
  if (pathname.match(/^\/session\//)) {
    if (activeView) {
      const viewTopicMap: Record<string, string> = {
        'dashboard': 'session-dashboard',
        'transcript': 'session-transcript',
        'avatars': 'session-avatars',
        'contributions': 'session-contributions',
        'guidance': 'session-guidance',
        'requirements': 'session-requirements',
        'decisions': 'session-decisions',
        'governance': 'session-governance',
        'tasks': 'session-tasks',
        'devices': 'session-devices',
        'second-screen': 'session-second-screen',
        'meetings': 'session-meetings',
      };
      if (viewTopicMap[activeView]) return viewTopicMap[activeView];
    }
    return 'session-dashboard';
  }

  // Project detail
  if (pathname.match(/^\/projects\/[^/]+/)) return 'project-detail';

  // Static route matches
  if (pathname === '/' || pathname === '/projects') return 'projects';
  if (pathname.startsWith('/create')) return 'session-creator';
  if (pathname.startsWith('/avatars')) return 'avatars-catalog';
  if (pathname.startsWith('/templates')) return 'templates-catalog';
  if (pathname.startsWith('/build')) return 'build-with-ai';

  return 'getting-started';
}
